export const CANONICAL_HOST = "thelifecyclecanvas.com";
export const CANONICAL_ORIGIN = `https://${CANONICAL_HOST}`;
